import React, { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import img_notify from "../../assets/images/birthday.webp";

const Notify = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // hiển thị 1 lần
    // const hasSeenPopup = localStorage.getItem("hasSeenPopupNotify");
    // if (!hasSeenPopup) {
    //   setOpen(true);
    //   localStorage.setItem("hasSeenPopupNotify", "true");
    // }
    // hiển thị mỗi lần mở
    const hasSeenPopup = sessionStorage.getItem("hasSeenPopupNotify");
    if (!hasSeenPopup) {
      setOpen(true);
      sessionStorage.setItem("hasSeenPopupNotify", "true");
    }
  }, []);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{
      style: {
        maxWidth: "800px",
        maxHeight: "600px",
        overflow: "hidden",
      },
    }}>
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <span 
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          cursor: "pointer",
          fontSize: "24px",
        }} 
        onClick={() => setOpen(false)}
      >
        ❌
      </span>
        <img
          src={img_notify} // Đổi thành đường dẫn ảnh của bạn
          alt="Popup"
          style={{ width: "100%", height: "auto", borderRadius: "8px" }}
        />
      </div>
    </Dialog>
  );
};

export default Notify;
